<template>
    <Box :title="'预防性计划验收('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">

            <div class="ArrayItems items" v-for="item in list" @click="$router.push({name: 'QualityTest', params:{item,ButtonExists:true}})">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <span class="ellipsis">{{item.OrderName}}</span>
                            <img src="../../assets/img/right.png" />
                        </div>
                        <div>
                            <div>
                                <p>资产名称:</p>
                                <p>实施日期:</p>
                                <p>执行人:</p>
                                <p>实施周期:</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.EquName}}</p>
                                <p class="ellipsis">{{item.KeepDate}}</p>
                                <p class="ellipsis">{{item.Executor}}</p>
                                <p class="ellipsis">{{item.KeepCycle}}</p>
                            </div>
                            <div class="button">
                                <div>预览</div>
                                <div @click.stop="acceptance(item)">验收</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span>计划单号</span>
                    <span>{{item.OrderNo}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" v-show="IsSee" key='1'>
                <Field title="计划名称" placeholder="请输入编号或者名称" @onMessage="value => search.JHDH = value" />
                <Field title="资产名称" placeholder="请输入编号或者名称" @onMessage="value => search.SBBH = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StarDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'PrecautionreceivingList',
        data() {
            return {
                search: {
                    JHDH: '',
                    SBBH: '',
                    StarDate: '',
                    EndDate: ''
                },
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0,
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated() {
            this.list = [];
            this.page = 10;
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.IsSee=false;
                this.list = [];
                this.page = 10;
                this.loadDataDefault();
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 10;
                    this.loadDataDefault();
                }
            },
            acceptance(item) { //验收
                 console.log(item);
                 this.$router.push({name:'PrecautionreceivingDefault',params:{item,pageState:1,Title:'预防性维护验收'}});
            },
            loadDataDefault() {
                this.$get('api/YF/GetPrecautionAcceptance', {
                    JHDH: this.search.JHDH,
                    SBBH: this.search.SBBH,
                    StarDate: this.search.StarDate,
                    EndDate: this.search.EndDate,
                    pageIndex: 1,
                    pageSize: this.page,
                    STORE: this.$UserInfo.StoreCode
                }).then(result => {
                    this.Total = result.Total;
                    this.list = result.BYList;
                    if (this.page >= this.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-top: 20px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/precautionreceivingList_YY/precautionreceivingList.vue